import { useEffect } from "react";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CharmsSection from "./components/CharmsSection";
import BasicInfoSection from "./components/BasicInfoSection";
import ForYouSection from "./components/ForYouSection";
import TestimonialsSection from "./components/TestimonialsSection";
import WhyClassLiveSection from "./components/WhyClassLiveSection";
import SchoolsSection from "./components/SchoolsSection";
import HighSchoolPreviewSection from "./components/HighSchoolPreviewSection";
import FAQSection from "./components/FAQSection";
import ContactSection from "./components/ContactSection";
import useJsonLd from "../../hooks/useJsonLd";

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL ?? "https://example.com";

  useEffect(() => {
    document.title = "ClassLive留学アイルランド | 語学留学・高校留学サポート";
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute("content", "ClassLive留学アイルランドは、ダブリンをはじめとするアイルランドへの語学留学・高校留学を手数料無料でサポート。ヨーロッパ現地に日本人スタッフも常駐で安心の留学生活をご提供します。");
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", `${siteUrl}/`);
  }, [siteUrl]);

  useJsonLd({
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": `${siteUrl}/#organization`,
        "name": "ClassLive留学アイルランド",
        "url": siteUrl,
        "telephone": "0120-963-815",
        "email": "info@ggjapan.jp",
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "0120-963-815",
          "contactType": "customer service",
          "availableLanguage": "Japanese",
          "contactOption": "TollFree",
          "areaServed": "JP"
        },
        "address": {
          "@type": "PostalAddress",
          "addressCountry": "IE",
          "addressLocality": "Dublin"
        },
        "description": "アイルランドへの語学留学・高校留学を完全無料でサポートする留学エージェント。現地スタッフ常駐で安心のサポートを提供。",
        "openingHoursSpecification": [
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            "opens": "10:00",
            "closes": "18:00"
          }
        ]
      },
      {
        "@type": "WebSite",
        "@id": `${siteUrl}/#website`,
        "url": siteUrl,
        "name": "ClassLive留学アイルランド",
        "description": "アイルランド語学留学・高校留学の完全無料サポートエージェント",
        "inLanguage": "ja",
        "publisher": {
          "@id": `${siteUrl}/#organization`
        }
      },
      {
        "@type": "EducationalOrganization",
        "@id": `${siteUrl}/#edu-org`,
        "name": "ClassLive留学アイルランド",
        "url": siteUrl,
        "description": "アイルランドへの語学留学・高校留学専門エージェント。ダブリン現地スタッフが日本語でサポート。",
        "address": {
          "@type": "PostalAddress",
          "addressCountry": "IE",
          "addressLocality": "Dublin"
        },
        "telephone": "0120-963-815",
        "email": "info@ggjapan.jp"
      }
    ]
  } as Record<string, unknown>);

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
      <Navbar />
      <main>
        <HeroSection />
        <CharmsSection />
        <BasicInfoSection />
        <ForYouSection />
        <TestimonialsSection />
        <WhyClassLiveSection />
        <SchoolsSection />
        <HighSchoolPreviewSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
